import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KycFlowStateService, KycStep } from '../services/kyc-flow-state.service';
import { KycService } from '../services/kyc.service';

/** Previene navegar a un step KYC no alcanzado. Redirige al currentStep si lo intenta. */
export function kycStepGuard(step: KycStep): CanActivateFn {
  return async () => {
    const router = inject(Router);
    const kycApi = inject(KycService);
    const kycState = inject(KycFlowStateService);

    if (!kycApi.getId()) {
      return router.createUrlTree(['/products']);
    }
    try {
      await kycState.hydrateFromBackend();
    } catch {
      return router.createUrlTree(['/products']);
    }

    const currentStep = kycState.currentStep;
    const steps = kycState.stepsArray;
    if (!currentStep || !steps.length) return true;

    const currentIdx = steps.indexOf(currentStep);
    const targetIdx = steps.indexOf(step);
    if (targetIdx > currentIdx) {
      const currentRoute = kycState.getRouteForStep(currentStep);
      return currentRoute ? router.createUrlTree([currentRoute]) : true;
    }
    return true;
  };
}
